import createModel, { prop } from '../lib/create_model';
import ConversationItem from '../conversation_item';
import CustomerProfile from '../customer_profile';
import NotificationType from './notification_type';

export default createModel({
  modelName: 'PaymentStatusEventNotification',

  properties: {
    id: prop(String), // AD only field
    conversationItem: prop(ConversationItem),
    profile: prop(CustomerProfile),
  },

  overrideToJs(toJs) {
    return () => ({ ...toJs(), type: NotificationType.PAYMENT_STATUS_EVENT });
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});
